import React, { useState, useEffect } from "react";
import { TrendingDown } from "lucide-react";
import { brokerShortsReport } from "../lib/api";

export const NexusShortsReport = ({ userId }) => {
  const [items, setItems] = useState([]);
  useEffect(() => { brokerShortsReport(userId).then((d) => setItems(d.items || [])).catch(() => {}); }, [userId]);
  return (
    <div className="rounded-2xl border border-[#ffffff14] bg-[#0a1020] p-4 space-y-2" data-testid="shorts-report-panel">
      <p className="flex items-center gap-2 text-cyan-100 font-semibold text-sm"><TrendingDown className="w-4 h-4 text-rose-300" /> Shorts report: why each crypto sweep did or didn't short</p>
      {items.length === 0 && <p className="text-cyan-200/40 text-xs" data-testid="shorts-report-empty">The first report appears after the next crypto sweep.</p>}
      {items.map((r) => (
        <div key={r.id} className="border-b border-[#ffffff08] pb-2 text-[11px]" data-testid="shorts-report-row">
          <p className="text-cyan-300/50">{String(r.created_at).slice(5, 16).replace("T", " ")} UTC · BTC {r.regime?.trend}</p>
          <p className="text-cyan-50">{r.verdict}</p>
          <p className="text-cyan-200/50">{(r.stages || []).map((s) => `${s.agent} ${s.shorts}`).join(" → ")}</p>
          {(r.reasons || []).slice(0, 3).map((x, i) => <p key={i} className="text-orange-300/80">{x}</p>)}
        </div>
      ))}
    </div>
  );
};
